import React, { ReactNode } from "react";

interface GuideSectionProps {
  id?: string;
  eyebrow: string;
  title: string;
  children: ReactNode;
  className?: string;
}

export function GuideSection({
  id,
  eyebrow,
  title,
  children,
  className = "bg-bg-white",
}: GuideSectionProps): JSX.Element {
  return (
    <section id={id} className={`py-32 relative ${className}`}>
      <div className="max-w-[1440px] mx-auto px-[5%]">
        <div className="mb-16 relative pl-8 border-l-2 border-l-solid border-l-brand-yellow">
          <span className="font-manrope text-xs tracking-wider uppercase text-text-slate block mb-2">
            {eyebrow}
          </span>
          <h2 className="page-section-heading">
            {title}
          </h2>
        </div>
        {children}
      </div>
    </section>
  );
}

interface FaqItem {
  question: string;
  answer: string;
}

export function FaqAccordion({ items }: { items: FaqItem[] }): JSX.Element {
  const [openIndex, setOpenIndex] = React.useState<number | null>(0);

  return (
    <div className="space-y-4">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.question}
            className="border border-solid border-[rgba(0,0,0,0.08)] bg-bg-porcelain"
          >
            <button
              type="button"
              className="w-full flex items-center justify-between gap-4 p-6 text-left font-teko text-2xl text-text-obsidian hover:text-brand-gold transition-colors"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
            >
              <span>{item.question}</span>
              <span
                className={`font-manrope text-2xl text-brand-yellow transition-transform ${
                  isOpen ? "rotate-45" : ""
                }`}
                aria-hidden
              >
                +
              </span>
            </button>
            {isOpen && (
              <div className="px-6 pb-6 font-manrope text-sm text-text-slate leading-relaxed border-t border-t-solid border-t-[rgba(0,0,0,0.06)] pt-4">
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
